module.exports = __webpack_public_path__ + "img/avatar-7.dc910b2a.jpg";